/**
 * Las piezas de la marca que sirve el propio sitio (`public/marca/`).
 *
 * Van con `?v=` por una razon concreta: el 22-09-2026, durante cerca de una
 * hora, una redireccion del sitio anterior (Caddyfile, `/marca/...`) mando
 * estas rutas a la portada con un 301. Un navegador guarda un 301 para
 * siempre y ya no le pregunta al servidor, asi que quien entro en esa hora
 * seguia sin ver el logo aunque el servidor ya estuviera bien. Cambiar la URL
 * es la unica forma de que lo vuelva a pedir. Si alguna vez hace falta otra
 * vez, se sube el numero aca (y en `index.html`, que no pasa por React).
 */
const VERSION = '2';

function conVersion(ruta: string): string {
  return `${ruta}?v=${VERSION}`;
}

export const MARCA = {
  logo: conVersion('/marca/logo.svg'),
  logoBlanco: conVersion('/marca/logo-blanco.svg'),
  icono180: conVersion('/marca/icono-180.png'),
  compartir: conVersion('/marca/compartir.jpg'),
} as const;
